export default __webpack_public_path__ + "static/media/avatar_180.9eac2bdf.png";